// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"7062ee3d2f071a29f1ca","655":"029148bad44d105b399a"}[chunkId] + ".js";
};